import { render } from "./ProgresRombel.vue?vue&type=template&id=08e5ff98"
import script from "./ProgresRombel.vue?vue&type=script&lang=js"
export * from "./ProgresRombel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__